/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import React from 'react'

import Bloc from './Bloc'
import Field from './Field'

export default function BudgetBloc({ configuration, values, tunnelData }) {

    const { budget } = configuration;

    return <Bloc hide={!budget} name='My budget'>
        <Field hide={!budget?.includes('netMonthlyIncome')} name={'Your net monthly income'}
               value={values.budget.numberMonthsIncome?.label ? `${values.budget.netMonthlyIncome} ${values.budget.numberMonthsIncome.label}` : values.budget.netMonthlyIncome}/>
        <Field hide={!budget?.includes('incomeOrigin')} name={'income Origin'} value={values.budget.incomeOrigin?.label} />
        <Field hide={!budget?.includes('detailOfIncome')} name={'detail Of Income'} value={values.budget.detailOfIncome} />
        <Field hide={!budget?.includes('otherIncome')} name={'Other monthly income'} value={values.budget.otherIncome} />
        <Field hide={!budget?.includes('rent')} name={'Your share of monthly charges'} value={values.budget.rent} />
        <Field hide={!budget?.includes('otherCharges')} name={'Other monthly charges'} value={values.budget.otherCharges} />
    </Bloc>

}
